import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import {BrowserRouter, Route } from 'react-router-dom'
import {Provider} from 'react-redux'
import ReactGA from 'react-ga';
import store from './store'

import Menu from './layout/Menu'
import MainArea from './MainArea'
import Test from './Test'

ReactGA.initialize('UA-55287583-1');
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter >
        <div className="App">
            <Menu/>
            <Route exact path="/main" component={MainArea} />
            <Route exact path="/" component={MainArea} />
            <Route exact path="/test" component={Test} />

        </div>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
